import { render } from "./about.vue?vue&type=template&id=45c3bcc4&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=45c3bcc4&scoped=true&lang=css"

import exportComponent from "D:\\办公\\projects\\drl-live\\drl-live-jk\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c3bcc4"]])

export default __exports__